export default {
  reports: {
    // Filtros por hito y jerarquía (R-33/R-34, §90)
    filtersTitle: "Filtros (opcional)",
    filtersClear: "Quitar filtros",
    channelAll: "Ambos canales",
    channelPharmacy: "Canal farmacia",
    channelHospital: "Canal hospital",
    hier_atc: "Código ATC",
    hier_ah: "Agrupación homogénea",
    hier_spr: "Conjunto de precios de referencia",
    hier_pa: "Principio activo",
    hier_nregistro: "Nº de registro",
    hier_cn: "Código nacional",
    hierPlaceholder_atc: "p. ej. C09CA (cualquier profundidad)",
    hierPlaceholder_ah: "código o nombre de la AH",
    hierPlaceholder_spr: "p. ej. F206",
    hierPlaceholder_pa: "p. ej. Olmesartán",
    hierPlaceholder_nregistro: "p. ej. 75012",
    hierPlaceholder_cn: "p. ej. 770428",
    opTitle: "Informe de Operación Inicial",
    opIntro: "Ejecuciones realizadas por fuente, eventos detectados y avisos emitidos, disponibilidad del periodo e incidencias con sus tiempos de respuesta y resolución.",
    opShort: "El periodo tiene {n} días: el informe de operación cubre al menos treinta días naturales.",
    opFrom: "Desde",
    opGoLive: "Puesta en producción: {date}. El periodo por defecto son los treinta días desde esa fecha.",
    opNoGoLive: "Sin fecha de puesta en producción registrada (se fija en la ficha de la organización).",
    opTo: "Hasta",
    opGenerate: "Generar PDF",
    title: "Informes",
    newTemplate: "+ Nueva plantilla",
    intro: "Plantillas de informe de tu organización: compón bloques a medida, guarda la configuración y genera el PDF cuando lo necesites.",
    noTemplates: "Aún no hay plantillas",
    noTemplatesWrite: "Crea tu primera plantilla combinando los bloques disponibles (KPIs, eventos, radar, CIPM…).",
    noTemplatesRead: "Un administrador o analista de tu organización puede crear plantillas de informe.",
    createTemplate: "Crear plantilla",
    generating: "Generando…",
    generate: "Generar",
    generateNow: "Generar ahora",
    edit: "Editar",
    delete: "Eliminar",
    lastReport: "Último informe: {date}",
    neverGenerated: "Nunca generado",
    deleteTitle: "¿Eliminar plantilla?",
    deleteMessage: "Se eliminará \"{name}\". Esta acción no se puede deshacer.",
    templateDeleted: "Plantilla eliminada",
    templateSaved: "Plantilla guardada",
    periodMonth: "Mes en curso",
    periodLastMonth: "Mes anterior",
    periodLastQuarter: "Trimestre anterior",
    periodCustom: "Personalizado",
    scopePortfolioAndCompetitors: "Portfolio y competencia",
    scopePortfolio: "Solo mi portfolio",
    scopeCompetitors: "Solo competencia",
    scopeMarket: "Mercado completo",
    scopeProduct: "Productos concretos",
    editTemplate: "Editar plantilla",
    newReportTemplate: "Nueva plantilla de informe",
    templateName: "Nombre de la plantilla",
    optionalToGenerate: "(opcional para generar)",
    templateNamePlaceholder: "Ej: Ciclo mensual dirección",
    pdfLanguage: "Idioma del PDF",
    spanish: "Español",
    english: "English",
    period: "Periodo",
    from: "Desde",
    to: "Hasta",
    scope: "Ámbito",
    noProducts: "Sin productos en tu portfolio.",
    reportSections: "Secciones del informe",
    addAtLeastOne: "Añade al menos una sección.",
    moveUp: "Subir",
    moveDown: "Bajar",
    removeSection: "Quitar sección",
    addSection: "Añadir sección",
    availableInUltra: "Disponible en el plan ULTRA",
    cancel: "Cancelar",
    preview: "Vista previa",
    downloadPdf: "Descargar PDF",
    saving: "Guardando…",
    saveChanges: "Guardar cambios",
    saveTemplate: "Guardar plantilla",
  },
};
